import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
// Clerk disabled - using custom JWT auth instead
// import { ClerkProvider } from '@clerk/clerk-react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

// Clerk disabled - using custom JWT auth
// const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Initialize PostHog
posthog.init(
  process.env.REACT_APP_POSTHOG_KEY,
  {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    person_profiles: 'identified_only',
    capture_pageview: false, // We'll handle pageviews manually for SPA
  }
);

// Register Service Worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        
        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              }
            });
          }
        });
      })
      .catch((error) => {
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
